import { Controller } from "@hotwired/stimulus";

/**
 * すべてのチェックボックスをまとめて操作する
 * @example
 * <div data-controller="check-all">
 * <input type="checkbox" data-check-all-target="all">
 * <input type="checkbox" data-check-all-target="item">
 * <input type="checkbox" data-check-all-target="item">
 */
export class CheckAllController extends Controller {
  static targets = ["all", "item"];

  connect() {
    this.allTarget.addEventListener("change", this.#handleAllChange);
  }

  itemTargetConnected(target) {
    target.addEventListener("change", this.#handleItemChange);
  }

  // allが変更されたらすべてのitemを同じ状態にする
  #handleAllChange = (e) => {
    if (!e.isTrusted) return;
    const checked = this.allTarget.checked;
    for (const item of this.#items()) {
      // 他のコントローラーのactionを発火するためclickイベントを発生させる
      const changed = item.checked !== checked;
      if (changed) item.click();
    }
  };

  // すべてのitemがチェックされたらallもチェックする
  #handleItemChange = () => {
    this.allTarget.checked = this.#items().every((item) => item.checked);
  };

  // disabledでないitem
  #items = () => {
    return this.itemTargets.filter((item) => !item.disabled);
  };
}
